import CalculateRateAge from './CalculateRateAge'
export default CalculateRateAge